/* @flow strict */

import * as React from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import { portalHelper } from '/client/src/utils/portalHelper';

type PropsType = {
  history: {
    goBack: () => void
  },
  withNested?: string,
  path?: string
};
type StateType = {
  portalIsset: boolean
};

class NavbarTitleBackAction extends React.Component<PropsType, StateType> {
  state = {
    portalIsset: false
  };

  portalSelector = '.sparxo-navbar-left';
  portalSelectorNested = '.sparxo-navbar-left-nested';

  componentDidMount() {
    const _self = this;

    portalHelper(
      _self.portalSelector,
      () => {
        if (this.props.withNested) {
          const el = document.querySelector(this.portalSelector);
          const NewElement = document.createElement('div');

          NewElement.id = 'portalSelectorNested';

          el.parentNode.insertBefore(NewElement, el.nextSibling);

          // Delay while div will be inserted to DOM
          setTimeout(() => {
            _self.setState({ portalIsset: true });
          }, 500);
        } else {
          _self.setState({ portalIsset: true });
        }
      }
    );
  }

  handleBack = (e: SyntheticEvent<HTMLLinkElement>) => {
    e.preventDefault();
    const { path, history } = this.props;

    if (path) {
      history.push(path);
    } else {
      history.goBack();
    }
  };

  render(): React.Element {
    const { portalIsset } = this.state;
    const child = (
      <>
        <a
          href="#"
          className="sparxo-navbar-back"
          onClick={this.handleBack}
        >
          <i className="icon icon-angle-left" />
          <span>back</span>
        </a>
      </>
    );

    if (!portalIsset) {
      return null;
    }

    return ReactDOM.createPortal(child, document.querySelector(this.portalSelector));
  }
}

export default withRouter(NavbarTitleBackAction);
